import { z } from 'zod'

export const contactCategories = [
	'Add a New Server',
	'Edit a Server',
	'Premium Access',
	'Website Enhancement',
	'Script Question',
	'Streamers',
	'Profiles',
	'Characters',
	'Other',
] as const

export const ContactFormSchema = z.object({
	name: z
		.string({ required_error: 'Name is required' })
		.min(2, 'Name must be at least 2 characters')
		.max(100),
	email: z
		.string({ required_error: 'Email is required' })
		.email('Please enter a valid email address'),
	subject: z
		.string({ required_error: 'Subject is required' })
		.min(3, 'Subject must be at least 3 characters')
		.max(200),
	message: z
		.string({ required_error: 'Message is required' })
		.min(10, 'Message must be at least 10 characters')
		.max(5000),
	category: z.string().optional(),
	server: z.string().optional(),
})

export const contactStatuses = ['new', 'read', 'responded', 'closed'] as const
export type ContactStatus = (typeof contactStatuses)[number]

export function getStatusBadgeColor(status: string) {
	switch (status) {
		case 'new':
			return 'bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-300'
		case 'read':
			return 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/40 dark:text-yellow-300'
		case 'responded':
			return 'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300'
		case 'closed':
			return 'bg-muted text-muted-foreground'
		default:
			return 'bg-muted text-muted-foreground'
	}
}
